import colors from '@/config/colors';
import { StyleSheet } from 'react-native';

export const styles = StyleSheet.create({
  text: { fontSize: 16 },

  divider: {
    width: '100%',
    height: 1,
    backgroundColor: colors.newUI.therapist.primaryBlue10,
    marginVertical: 20,
  },

  longLabelContainer: { maxWidth: '80%', gap: 8 },

  leftBorder: {
    width: 2,
    backgroundColor: colors.newUI.therapist.textBlue100,
    marginRight: 12,
  },

  modalFooter: { flexDirection: 'row', justifyContent: 'flex-end', gap: 16 },
});
